// extracted by mini-css-extract-plugin
export default {"pagination":"Pagination_pagination__qV0XY","paginationItem":"Pagination_paginationItem__Ws685","active":"Pagination_active__S+stY"};